export default __webpack_public_path__ + "static/media/about-img.b3e6dfb0.jpg";